// extracted by mini-css-extract-plugin
export default {"settingContainer":"Account_settingContainer__A1mu5"};